import { Route, Routes as RoutesDOM } from "react-router-dom";
import { Login } from "../pages/Login/Login";
import PrivateRoute from "./PrivateRoute";
import { Dashboard } from "../pages/Dashboard/Dashboard";
import { NewPassword } from "../pages/NewPassword/NewPassword";
import { Compagnies } from "../pages/Compagnies/Compagnies";
import { Services } from "../pages/Services/Services";
import { Department } from "../pages/Department/Department";
import Retranscription from "../pages/Retranscription/Retranscription";
import { CarsGeneric } from "../pages/CarsGeneric/CarsGeneric";
import { UsersGeneric } from "../pages/UsersGeneric/UsersGeneric";
import { Sign } from "../pages/Sign/Sign";
import { Parameter } from "../pages/Parametre/Parametre";
import { Pubs } from "../pages/Pub/Pub";
import { Brands } from "../pages/Brands/Brands";
import { Billing } from "../pages/Billing/Billing";
import { Poi } from "../pages/Poi/Poi";
import { Audit } from "../pages/Audit/Audit";
import { Onboarding } from "../pages/Onboarding/Onboarding";

export const Routes = () => {
  const isAuthentificated = !!localStorage.getItem("token");
  return (
    <RoutesDOM>
      <Route
        path="/"
        element={
          isAuthentificated ? (
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          ) : (
            <Login />
          )
        }
      />
      <Route path="/new_password" element={<NewPassword />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <PrivateRoute permission="fleet.user.manage">
            <UsersGeneric />
          </PrivateRoute>
        }
      />
      <Route
        path="/users"
        element={
          <PrivateRoute permission="fleet.user.manage">
            <UsersGeneric />
          </PrivateRoute>
        }
      />
      <Route
        path="/cars"
        element={
          <PrivateRoute permission="fleet.vehicle.manage">
            <CarsGeneric />
          </PrivateRoute>
        }
      />
      <Route
        path="/services"
        element={
          <PrivateRoute permission="catalogue.service.manage">
            <Services />
          </PrivateRoute>
        }
      />
      <Route
        path="/signs"
        element={
          <PrivateRoute permission="catalogue.sign.manage">
            <Sign />
          </PrivateRoute>
        }
      />
      {/*
        Centres & Stations (POI ingestion). Gated on catalogue.sign.manage
        rather than a new catalogue.poi.manage: an unseeded permission makes
        the screen invisible to everyone, including the person who added it.
        Seed a dedicated permission first if you want to split the two.
      */}
      <Route
        path="/poi"
        element={
          <PrivateRoute permission="catalogue.sign.manage">
            <Poi />
          </PrivateRoute>
        }
      />
      <Route
        path="/pubs"
        element={
          <PrivateRoute permission="catalogue.pub.manage">
            <Pubs />
          </PrivateRoute>
        }
      />
      <Route
        path="/brands"
        element={
          <PrivateRoute permission="catalogue.brand.manage">
            <Brands />
          </PrivateRoute>
        }
      />
      <Route
        path="/billing"
        element={
          <PrivateRoute anyOf={["billing.plan.view", "billing.pricing.view", "billing.promo.view", "billing.settings.view"]}>
            <Billing />
          </PrivateRoute>
        }
      />
      <Route
        path="/parametres"
        element={
          <PrivateRoute permission="platform.parameters.manage">
            <Parameter />
          </PrivateRoute>
        }
      />
      <Route path="/compagnies">
        <Route
          path=""
          element={
            <PrivateRoute permission="fleet.company.manage">
              <Compagnies />
            </PrivateRoute>
          }
        />
        <Route
          path="users/:id"
          element={
            <PrivateRoute permission="fleet.user.manage">
              <UsersGeneric />
            </PrivateRoute>
          }
        />
        <Route
          path="vehicules/:id"
          element={
            <PrivateRoute permission="fleet.vehicle.manage">
              <CarsGeneric />
            </PrivateRoute>
          }
        />
        <Route
          path=":id/departments"
          element={
            <PrivateRoute permission="fleet.company.manage">
              <Department />
            </PrivateRoute>
          }
        />
      </Route>
      {/*
        Accueil — sante du parcours d'entree des clients.

        Garde sur `fleet.user.manage`, la meme clef que les ecrans Utilisateurs
        et Societes, et la meme que celle exigee par OnboardingController.
        Volontairement PAS une clef neuve : une permission non semee rend
        l'ecran invisible pour tout le monde, y compris pour la personne qui
        vient de l'ajouter (voir la note sur /poi juste au-dessus). Si une
        separation lecture/action devient necessaire, semer les clefs AVANT de
        les exiger.
      */}
      <Route
        path="/accueil"
        element={
          <PrivateRoute permission="fleet.user.manage">
            <Onboarding />
          </PrivateRoute>
        }
      />
      <Route
        path="/retranscription"
        element={
          <PrivateRoute permission="platform.retranscription.view">
            <Retranscription />
          </PrivateRoute>
        }
      />
      {/*
        Journaux — audit trail + system logs.
        Gated on platform.audit.view, the SAME key the API authorises on, so
        the menu, the screen and the server all agree. Export is a separate
        permission checked inside the screen (the button hides) and again on
        the endpoint (the real enforcement).
      */}
      <Route
        path="/journaux"
        element={
          <PrivateRoute permission="platform.audit.view">
            <Audit />
          </PrivateRoute>
        }
      />
    </RoutesDOM>
  );
};
